/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import jwt from 'jsonwebtoken'
import store from './store/store'
import VueCookie from 'vue-cookie'
import {isMobile} from 'mobile-device-detect'

import routerAdmin from './router/router-admin'
import routerMobile from './router/router-mobile'
import routerMobileProject from './router/router-mobile-project'
import routerProject from './router/router-project'
import routerMain from './router/router-main'
import routerList from './router/list'
import routerWrite from './router/write'

Vue.use(Router)

/**
 * 관리자 페이지 권한 체크
 * @returns {function(*, *, *): void}
 */
function requireAdminPage (to, from, next) {

  const methods = to.path.split('/')
  const adminPath = 'myAdmin'

  // 사용권한이 있을 경우에만 접근하도록 한다.

  // 관리자페이지에서 설정한 경로와 일치하는지 확인한다.
  if (methods.length > 1 && methods[1] === adminPath) {
  } else {
    next('/')
  }
}

/**
 * 권한 체크
 * @returns {function(*, *, *): (*)}
 */
async function requireAuth (to, from, next) {

  let userToken = store.state.auth.userToken
  let isAuthenticated = false

  if (!userToken || userToken === '') {
    userToken = VueCookie.get('token')
  }
  if (userToken) {
    try {
      // jwt.decode 로 만료 기간 체크 (exp)
      const decToken = jwt.decode(userToken)
      const currentTime = new Date().getTime() / 1000

      if (currentTime < decToken.exp) {
        isAuthenticated = true
      }

      // eslint-disable-next-line no-empty
    } catch (err) {

    }
  } else {
    VueCookie.delete('token') // 현재 토큰 제거
    VueCookie.delete('current_id') // 현재 보고있는 게시물 넘버
  }

  // 게스트도 볼 수 있는가? 체크
  // api 제작필요.

  // 게스트는 볼 수 없는 경우
  // 내가 보려고하는 페이지에 권한이 있는가 체크
  // 나의 권한 가져오기 api 제작필요

  if (!isAuthenticated) {
    await store.dispatch('REFRESH_TOKEN').catch(err => {
      VueCookie.delete('token') // 현재 토큰 제거
      VueCookie.delete('current_id') // 현재 보고있는 게시물 넘버
      return next('/login')
    })
  }
  await store.dispatch('USER_INFO')

  // 사용자 등급
  const position = store.state.auth.userInfo.position
  let nextPosition = to.meta && to.meta.authPosition
  const rootMeta = to.matched.length > 0 ?  to.matched[0].meta : undefined

  if (!nextPosition) {
    if (rootMeta) {
      nextPosition = rootMeta.authPosition
    }
  }

  if (nextPosition) {
    if (position > nextPosition) {
      // 내 프로젝트로 이동시키기.
      await store.dispatch('project/LOAD_PROJECT_LIST', {
        page: 1,
        perPage: 100,
        onlyMe: 1
      })

      // 게시물 불러오기
      const projectListInfo = store.state.project.projectListInfo
      const myProjectList = projectListInfo.data
      if (myProjectList.length > 0) {
        const lastProjectId = myProjectList[0].id
        return next(`/project/${lastProjectId}`)
      } else {
        alert('참여가능한 프로젝트가 없습니다.')
        return next('/login')
      }
    }
  }


}


// device check
function requireMobile (to, from, next) {

  const path = to.fullPath.split('/')
  if (isMobile) {
    if (path[1] !== 'm') {

      return next(`/m${to.path}`)
    }
  } else if (path[1] === 'm') {
    path.removeIndex(1)
    let url = ''
    for (let i = 0; i < path.length; i++) {
      if (i > 0) {
        url += '/'
      }
      url += path[i]
    }
    return next(url)
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    ...routerAdmin,
    ...routerMobileProject,
    ...routerMobile,
    ...routerProject,
    ...routerMain,
    ...routerList,
    ...routerWrite,
    {
      path: '',
      component: () => import('@/layouts/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES - WEB
        // =============================================================================
        // login
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta:{
            deviceRequired: true
          }
        },
        {
          path: '/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/login/ResetPassword.vue')
        },
        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/login/ForgotPassword.vue')
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },

        // =============================================================================
        // PAGES - MOBILE
        // =============================================================================
        {
          path: '/m/login',
          name: 'm-page-login',
          component: () => import('@/views/pages/login/MobileLogin.vue'),
          meta:{
            deviceRequired: false
          }
        },
        {
          path: '/m/register',
          name: 'm-page-register',
          component: () => import('@/views/pages/register/MobileRegister.vue')
        },
        {
          path: '/m/pages/error-404',
          name: 'm-page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})


router.beforeEach((to, from, next) => {
  const checkAdminRequired = to.matched.some(function (routeInfo) { return routeInfo.meta.adminRequired })
  const checkAuthRequired = to.matched.some(function (routeInfo) { return routeInfo.meta.authRequired })
  const checkMobile = to.matched.some(function (routeInfo) { return routeInfo.meta.deviceRequired })


  // 관리자 여부
  if (checkAdminRequired) {
    requireAdminPage(to, from, next)
  }

  // 로그인 여부
  if (checkAuthRequired) {
    requireAuth(to, from, next)
  }

  // 모바일 여부
  // if (checkMobile) {
  //   requireMobile(to, from, next)
  // }

  next()
})


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
